import { render, staticRenderFns } from "./DialogFormOutput.vue?vue&type=template&id=0b925b5e&"
import script from "./DialogFormOutput.vue?vue&type=script&lang=ts&"
export * from "./DialogFormOutput.vue?vue&type=script&lang=ts&"
import style0 from "./DialogFormOutput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports